import {
  VERIFY_EMAIL,
  VERIFY_EMAIL_SUCCESSFUL,
  VERIFY_EMAIL_FAILED,
  RESET_PASSWORD, RESET_PASSWORD_FAILED, RESET_PASSWORD_SUCCESSFUL

} from "./actionTypes"

const { data, ...authUser } = JSON.parse(
  localStorage.getItem("authUser") || "{}",
)


const initialState = {
  message: null,
  loading: false,
  user: data || {},
  authToken: data?.Token || null,
}

 /**
      * Used for handling auth user api
      */

const verify = (state = initialState, action) => {
  switch (action.type) {
    case VERIFY_EMAIL:
      return {
        ...state,
        user: null,
        loading: true,
      }

    case VERIFY_EMAIL_SUCCESSFUL:
      return {
        ...state,
        loading: false,
      }

    case VERIFY_EMAIL_FAILED:
      return {
        ...state,
        user: null,
        loading: false,
      }
      case RESET_PASSWORD:
        return {
          ...state,
          user: null,
          loading: true,
        }
  
      case RESET_PASSWORD_SUCCESSFUL:
        return {
          ...state,
          loading: false,
        }
  
      case RESET_PASSWORD_FAILED:
        return {
          ...state,
          user: null,
          loading: false,
        }
  
    default:
      return state
  }
}

export default verify
